import React from "react";
import Meta from "./../components/Meta";
import DashboardSection from "./../components/DashboardSection";
import { requireAuth } from "./../util/auth";
import "./dashboard.scss";

function DashboardPage(props) {
  return (
    <div className="dashboard-page">
      <Meta title="Profile" />
      <DashboardSection
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Profile"
        subtitle=""
      />
    </div>
  );
}

export default requireAuth(DashboardPage);
